// Six tabs, not eight: vouchers live inside "Packages & Vouchers" and sport levels
// inside "Preferences" (legacy ?tab=vouchers / ?tab=sports URLs are coerced in
// DashboardView).
export const ACTIVITY_TABS = [
  { value: "overview", label: "Overview" },
  { value: "bookings", label: "Bookings" },
  { value: "terms", label: "Programs" },
  { value: "packages", label: "Packages & Vouchers" },
  { value: "invoices", label: "Invoices" },
  { value: "preferences", label: "Preferences" }
];

// Bookings tab filter/sort options. Defaults: scope "upcoming", no status, sort "date".
export const BOOKING_SCOPE_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "upcoming", label: "Upcoming" },
  { value: "past", label: "Past" },
  { value: "all", label: "All" }
];

export const BOOKING_STATUS_OPTIONS = [
  { value: "unpaid", label: "Unpaid" },
  { value: "paid", label: "Paid" },
  { value: "cancelled", label: "Cancelled" }
];

// Only the types the client actually has are offered (the server sends them), and the
// row is hidden when there is just one. Semi-private lessons count as lessons.
export const BOOKING_TYPE_OPTIONS = [
  { value: "class", label: "Group Classes" },
  { value: "private", label: "Private Lessons" },
  { value: "court", label: "Court Rentals" }
];

export const BOOKING_SORT_OPTIONS = [
  { value: "date", label: "By date" },
  { value: "recent", label: "Recently booked" }
];

// Invoices tab filter/sort. No status selected = all. Default sort "date" (newest).
export const INVOICE_STATUS_OPTIONS = [
  { value: "unpaid", label: "Unpaid" },
  { value: "paid", label: "Paid" },
  { value: "refunded", label: "Refunded" },
  { value: "writeoff", label: "Write-off" }
];

export const INVOICE_SORT_OPTIONS = [
  { value: "date", label: "By date" },
  { value: "amount", label: "By amount" }
];

// SETTLED means the invoice was consolidated into another one that has been
// paid, so the client owes nothing on it — but it isn't the same event as
// paying this invoice, hence its own palette entry rather than success.
// PARTIAL_SETTLED still carries a balance, so it stays in the unpaid palette.
// PENDING_PACKAGE is a session booked against a package the club has not been paid
// for yet. The client owes nothing on it — the balance sits on the package purchase —
// so it must not borrow the red the unpaid palette uses. Info keeps it visible without
// reading as a bill.
export const INVOICE_PILL_COLOR = {
  PAID: "success",
  SETTLED: "settled",
  UNPAID: "error",
  PARTIAL: "warning",
  PARTIAL_SETTLED: "warning",
  PENDING: "warning",
  PENDING_PACKAGE: "info",
  VOIDED: "default",
  REFUND: "info",
  REFUND_PENDING: "warning",
  WRITEOFF: "warning"
};

// The raw status is the pill's label everywhere else, so only the ones that don't read
// as English need an entry here.
export const INVOICE_PILL_LABEL = {
  PENDING_PACKAGE: "Pending package",
  PARTIAL: "Partially paid",
  PARTIAL_SETTLED: "Partial settled",
  REFUND_PENDING: "Refund pending",
  WRITEOFF: "Write-off"
};

// Depleted and expired both mean "you can't spend this", but they're opposite
// outcomes for the client — used in full versus lapsed with the value lost —
// so they can't share grey. Blue keeps depleted quiet without reading as a
// loss; grey is left for expired, which really is dead money.
export const VOUCHER_PILL_COLOR = {
  active: "success",
  pending: "warning",
  frozen: "warning",
  depleted: "info",
  expired: "default"
};

export const BOOKING_PILL_COLOR = {
  NEW: "primary",
  // A PENDING row is a seat held by an unpaid package purchase (shown as
  // "RESERVED") — warning reads as in-progress, which it is.
  PENDING: "warning",
  ATTENDED: "success",
  NOSHOW: "warning",
  CANCELED: "error"
};

// React state updates from useFetch are async, so when the user switches tabs
// there's one render where `items` still holds the previous tab's payload.
// Each tab carries a marker field unique to its shape — we drop items that
// don't have it so child rows never see a stale-shape document.
export const TAB_DISCRIMINATORS = {
  bookings: "bookingStatus",
  terms: "startDate",
  packages: "kind",
  vouchers: "remainValue",
  invoices: "invoiceNumber"
};

export const REFUND_METHOD_LABEL = {
  WALLET: "Wallet credit",
  ONLINE: "Refund to original card"
};

export const REFUND_METHOD_HELPER = {
  WALLET: "Stored as wallet credit you can spend on a future booking.",
  ONLINE: "Pushed back to the card you paid with (usually within 7 working days)."
};
